import { ACTION_CASHOUT_HISTORY, ACTION_CASHOUT_HISTORY_ERROR, ACTION_CASHOUT_HISTORY_SUCCESS } from "."
import * as api from "../../../api"
import * as authActions from "../../auth/actions";

export const getCashoutHistoryRequest = (access_token, appInfo, url) => ({
    type: ACTION_CASHOUT_HISTORY,
    payload: {
        access_token,
        appInfo,
        url
    }
})

export const getCashoutHistorySuccess = data => ({
    type: ACTION_CASHOUT_HISTORY_SUCCESS,
    payload: {
        data
    }
})


export const getCashoutHistoryError = (msg) => ({
    type: ACTION_CASHOUT_HISTORY_ERROR,
    payload: {
        msg
    }
})

export const getCashoutHistory = (access_token, appInfo, url) => {
    return dispatch => {
        dispatch(getCashoutHistoryRequest(access_token, appInfo, url))
        api.getCashoutHistory(access_token, appInfo, url)
            .then(({ data }) => {
                if (data.result.code !== 0) {
                    dispatch(getCashoutHistoryError("error"));
                    return
                }

                const {histories} = data
                dispatch(getCashoutHistorySuccess(histories));
            }).catch((err) => {

                console.log(err)

                if (err.response) {
                    if (err.response.status === 401) {
                        dispatch(authActions.logout())
                        return
                    }
                }

                dispatch(getCashoutHistoryError("system error"))
            });
    }
}